/**
 * Where a queued payment's figures are really kept, when they are kept somewhere else.
 *
 * A loan payment's "pay others" lines, the per-payment servicing fee and a charge's splits are
 * reconciled from that payment every time it is saved: editing the queued payment here would be
 * thrown away the next time anybody touched it. An approved voucher is the same problem read the
 * other way round - the voucher is the authorization, so the amount approved on it has to stay the
 * amount about to be paid.
 *
 * Those are shown with their origin instead of an Edit link, and the server refuses them with the
 * same reason (`payableOwnedElsewhere` in the backend's `utils/payable-edit-rules.ts`). Everything
 * else - keyed in by hand, a suggestion that was accepted, an invoice queued from the Invoices
 * screen - is owned by this screen and editable until its check is issued.
 */
const OWNER_LABEL: Record<string, string> = {
  payment: 'From a loan payment',
  'servicing-fee': 'From a loan payment',
  'charge-split': 'From a charge split',
  voucher: 'From a voucher',
}

/** A label naming the record this payment comes from, or '' when this screen owns it. */
export function belongsToAnotherRecord(sourceType?: string | null): string {
  return OWNER_LABEL[String(sourceType || '').toLowerCase()] || ''
}
